import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const sendManualCampaign = async (domain: string, campaignId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `campaigns/${campaignId}/send`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}